export const OpenLinkIcon = ({ className }: { className: string }) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3001 5.6C13.6867 5.6 14 5.2866 14 4.9V0.7C14 0.313404 13.6867 0 13.3001 0H9.09834C8.71179 0 8.39846 0.313397 8.39846 0.7C8.39846 1.0866 8.71179 1.4 9.09834 1.4H11.6106L5.587 7.42462C5.31369 7.69797 5.31369 8.14121 5.587 8.41456C5.86035 8.68798 6.30345 8.68798 6.57675 8.41456L12.6002 2.39006V4.9C12.6002 5.2866 12.9136 5.6 13.3001 5.6ZM2.09963 2.1C0.94004 2.1 0 3.04021 0 4.2V11.9C0 13.0598 0.94004 14 2.09963 14H9.79828C10.9579 14 11.8979 13.0598 11.8979 11.9V7.7C11.8979 7.31339 11.5846 7 11.198 7C10.8115 7 10.4982 7.31339 10.4982 7.7V11.9C10.4982 12.2866 10.1848 12.6 9.79828 12.6H2.09963C1.7131 12.6 1.39976 12.2866 1.39976 11.9V4.2C1.39976 3.8134 1.7131 3.5 2.09963 3.5H6.2989C6.68544 3.5 6.99878 3.1866 6.99878 2.8C6.99878 2.4134 6.68544 2.1 6.2989 2.1H2.09963Z"
        fill="currentColor"
      />
    </svg>
  )
}
